/**
 * A method to convert target URLs and image source URLs use the https://
 * protocol. Utility owner does not guarantee that the https URLs and images
 * will resolve automatically. Vertical owners need to use this function and
 * validate if the resource that provide http (some resources might not exist
 * behind HTTPS URLs).
 *
 * This is being added initially for Iris. Other consumers of the utility may
 * proceed with caution.
 *
 * please also modify enforceSecureUrl in packages/core-utilities/src/enforceSecureUrl.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 *
 * @param url The original url
 * @returns The url that converted to https
 */
export function enforceSecureUrl(url: string): string {
    return url && url.replace(/^http:\/\//i, "https://");
}

/**
 * please also modify isHttpUrl in packages/core-utilities/src/enforceSecureUrl.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 */
// tslint:disable-next-line: no-http-string
const httpPrefix = "http://";
export const isHttpUrl = (url: string) => {
    if (url.startsWith(httpPrefix)) {
        return true;
    }

    return false;
};
